export const CAMERA_BUTTON_OFF = 'camera-button-off'
export const CAMERA_BUTTON_ON = 'camera-button-on'
export const CHAT_BUTTON_SHOW = 'chat-button-show'
export const CHAT_BUTTON_HIDE = 'chat-button-hide'
export const DIALING_CONTAINER = 'dialing-container'

export const LIVE_HELPER_WIDGET_CONTAINER = 'live-helper-widget-container'
export const LIVE_HELPER_WIDGET_BASE_CONTAINER =
  'live-helper-widget-base-container'

export const MESSAGE_PREVIEW_WRAPPER = 'message-preview-wrapper'
export const MICROPHONE_BUTTON_MUTED = 'microphone-button-muted'
export const MICROPHONE_BUTTON_UNMUTED = 'microphone-button-unmuted'
export const PRIVACY_ALERT = 'privacy-alert'
export const TRIPLE_DOT_LOADER = 'triple-dot-loader'
export const QUEUE_POSITION_CONTAINER = 'queue-position-container'

export const FIRST_NAME_INPUT = 'first-name-input'

export const EMAIL_INPUT = 'email-input'

export const NEXT_BUTTON = 'next-button'

export const SUBMIT_BUTTON = 'submit-button'

export const START_CALL = 'start-call'

export const TERMINATE_CALL = 'terminate-call'
